// extracted by mini-css-extract-plugin
export default {"logBody":"log-body__uXP8duIz","logUpdated":"log-updated__GWAEHRPp"};